import React, { useState, useEffect } from 'react';
import { Container, Table, Card } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../utils/axiosConfig'; // Using your configured axios instance

const MySchedule = () => {
  const { user } = useAuth();
  const [interviews, setInterviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInterviews = async () => {
      try {
        const response = await api.get('accounts/personal/interviews/');
        setInterviews(response.data.interviews || []);
      } catch (err) {
        setError('Failed to fetch interviews');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchInterviews();
    } else {
      setError('User not authenticated');
      setLoading(false);
    }
  }, [user]);

  if (loading) {
    return <Container className="mt-4">Loading...</Container>;
  }

  if (error) {
    return <Container className="mt-4 text-danger">Error: {error}</Container>;
  }

  return (
    <Container className="mt-4">
      <h2 className="mb-4">My Scheduled Interviews</h2>
      {interviews.length === 0 ? (
        <p>No scheduled interviews found.</p>
      ) : (
        <Card>
          <Card.Body>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Round</th>
                  <th>Interviewer</th>
                  <th>Location</th>
                  <th>Time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {interviews.map((interview) => (
                  <tr key={interview.id}>
                    <td>{interview.company?.name || 'N/A'}</td>
                    <td>{interview.round?.number || 'N/A'}</td>
                    <td>{interview.panel?.interviewer || 'N/A'}</td>
                    <td>{interview.panel?.place || 'N/A'}</td>
                    <td>
                      {interview.time_slot?.start_time} - {interview.time_slot?.end_time}
                    </td>
                    <td>{interview.status || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default MySchedule;